











import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { config } from "../config";
import { IToken, ITokenNetwork } from "../interfaces";

@Component
export default class AlertMessage extends Vue {
    @Prop({ required: true }) public message: string;
    @Prop({ default: "info" }) public type: string;
    @Prop({ default: 5000 }) public duration: number;
    @Prop({ default: false }) public dismissible: boolean;
}
